import { configureStore } from '@reduxjs/toolkit';
import { combineReducers, Store } from 'redux';
import { api, rtkQueryErrorLogger } from 'store/api';

const combinedReducer = combineReducers({
  [api.reducerPath]: api.reducer
});

export const store = configureStore({
  reducer: combinedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware, rtkQueryErrorLogger)
});

export type AppDispatch = Store['dispatch'];
export type RootState = ReturnType<Store['getState']>;
